import * as React from 'react';
import { AutoprolongContainer } from '../Autoprolong';
import * as styles from './Actions.css';

interface IActionsProps {
  cancel: React.ReactNode;
  confirm: React.ReactNode;
}

export const Actions = (props: IActionsProps) => {
  const { cancel, confirm } = props;

  return (
    <div className={styles['actions']}>
      <AutoprolongContainer />

      <div className={styles['buttons']}>
        <div className={styles['button']}>{cancel}</div>

        <div className={styles['button']}>{confirm}</div>
      </div>
    </div>
  );
};
